<template>
  <div>
    <el-table v-loading="loading" :data="tableData" border :cell-style="{padding:0,borderColor:'#000000'}"
            :header-cell-style="{borderColor:'#000000',color:'#0099ff'}" style="width: 100%;border: 1px solid #000000" :row-style="{height:'100px'}">
      <el-table-column prop="site" label="站点" width="110px" align="center"> </el-table-column>
      <el-table-column prop="ID_" label="订单id" width="90px" align="center"> </el-table-column>
      <el-table-column prop="status" label="订单状态" width="100px" align="center"> </el-table-column>
      <el-table-column prop="date_created_gmt" label="下单时间" width="160px" align="center"> </el-table-column>
      <el-table-column prop="date_paid_gmt" label="付款时间" width="160px" align="center"> </el-table-column>
      <el-table-column prop="name" label="姓名" width="150px" align="center"> </el-table-column>
      <el-table-column prop="email" label="邮箱" width="200px" align="center"> </el-table-column>
      <el-table-column prop="phone" label="手机号" width="130px" align="center"> </el-table-column>
      <el-table-column prop="total" label="订单总额" width="100px" align="center"> </el-table-column>
      <el-table-column prop="shiptype" label="运输方式" width="90px" align="center"> </el-table-column>
      <el-table-column prop="customer_note" label="客户备注" align="center"> </el-table-column>
      <!-- <el-table-column
        width="100px"
        label="操作"
        v-loading="loading"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-view"
            @click="details(scope.$index, scope.row)"
            plain
            >查看</el-button>
        </template>
      </el-table-column> -->
      <el-table-column
          prop="payment_method"
          label="支付方式"
          width="80px"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="transaction_id"
          label="交易号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="bbun"
          label="贝宝用户名"
          align="center"
        ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getOrder } from "../../api/api";
export default {
  data() {
    return {
      tableData: [], //订单列表
      loading: true,
    };
  },
  created() {
    var un = window.localStorage.getItem('un');
    if(un == '' || un == null || un == undefined){
      this.loading = true;
      return false;
    }
    var id_ = this.$route.query.id;
    // var params = {
    //   id_:this.$route.query.id
    // }
    // console.log(params);
    getOrder(id_).then((res) => {
      // for(var BB of res){
      //   if(BB.site == 'madrid-shop'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }else if(BB.site == 'cuirz'){
      //     BB.bbun = 'cuirz';
      //   }else if(BB.site == 'nihonbro'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }else if(BB.site == 'jleague-shop'){
      //     BB.bbun = 'libicheng23@163.com';
      //   }else if(BB.site == 'supermaillot'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }else if(BB.site == 'fortmaillot'){
      //     BB.bbun = 'vocotopa@gmail.com';
      //   }else if(BB.site == 'kickitshirts'){
      //     BB.bbun = 'madridshop.cc@gmail.com';
      //   }else if(BB.site == 'mailloten'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }else if(BB.site == 'ligafoot'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }else if(BB.site == 'beazl'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }else if(BB.site == 'top-w'){
      //     BB.bbun = 'onlinehossam4@gmail.com';
      //   }
      // }
      // for(var i of res){
        // 可以通过ID_、name、email搜索
          // if(i.ID_ == id_ || i.name == id_ || i.email == id_ || i.transaction_id == id_){
              this.tableData = res;
          // }
      // }
      this.loading = false;
    });
  },
  methods: {
    //查看详情
    details(index, row){
      const detail_ = this.$router.resolve({ path: "/home/Orderdetail", query: { id: row.id } });
      window.open(detail_.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped></style>
